// umiAPI/React
import { useState } from 'react';

// 枚举
import { CoinTypeEnum } from '@/enums/businessEnum';
// api
import { getIndexApi } from '@/services/api/requestApi';
import { useReq } from '@/services/net/request';
//
import { useTranslation } from 'react-i18next';

// src/models/userModel.ts
export default function () {
  const { t } = useTranslation();

  /**
   * @description 获取指数
   */
  const { run: getSymbolIndexRequest, data: symbolIndexList = [] as any } =
    useReq(getIndexApi, {
      manual: true,
      formatResult: (res: any) => {
        return res?.data ?? [];
      },
    });
  /******************************* 币种列表 *************************************/
  // 币种列表
  const currencyTabs = [
      {
        text: t('热门墨西哥股票'),
        value: CoinTypeEnum.MEXICO_STOCK,
      },
      {
        text: t('热门美国股票'),
        value: CoinTypeEnum.US_STOCKS,
      },

      // {
      //   text: t('外汇'),
      //   value: CoinTypeEnum.FOREIGN_EXCHANGE,
      // },
      // {
      //   text: t('虚拟币'),
      //   value: CoinTypeEnum.CONTRACT,
      // },
      // {
      //   text: t('股票合约'),
      //   value: CoinTypeEnum.STOCKS_CONTRACT,
      // },
      // {
      //   text: t('合约'),
      //   value: CoinTypeEnum.CONTRACT,
      // },
    ];
  // 当前tab
  const [currentCurrencyTab, setCurrentCurrencyTab] = useState(
    CoinTypeEnum.MEXICO_STOCK,
  );
  // 是否有数据
  const [hasData, setHasData] = useState(false);

  return {
    getSymbolIndexRequest,
    symbolIndexList,
    currencyTabs,
    currentCurrencyTab,
    setCurrentCurrencyTab,
    hasData,
    setHasData,
  };
}
